import { useTranslation } from "@msuite/ui/localization";
import type { Tables } from "@msuite/utils/types";
import UserCard from "@/components/cards/user-card";

/** Props Interface */
interface ProjectTimelineAuditInsertItemProps {
	item: Tables<"projectsAudit">;
}

export function ProjectTimelineAuditInsertItem({ item }: ProjectTimelineAuditInsertItemProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Guard */
	if (!item.changedBy) {
		return (
			<div className="h-stack">
				<p>{t("projects._system_created_this_project")}.</p>
			</div>
		);
	}

	/** Render */
	return (
		<div className="h-stack">
			<UserCard
				userId={item.changedBy}
				variant="plain"
				fontSize="md"
			/>
			<p className="-ml-1">{t("projects._created_this_project")}.</p>
		</div>
	);
}
